









// accordion start


$(".accordion__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion__link").slideUp();
    } else {
        // $(".accordion__link").slideUp();
        // $(".accordion__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion__link").slideDown();
    }
})



// accordion end




// search-close-icon start


$(document).ready(function () {
    const $input = $('.help-hero__search input');
    const $closeIcon = $('.search-close-icon');

    // Show close icon when there is text in the input
    $input.on('input', function () {
        if ($(this).val().length > 0) {
            $closeIcon.addClass('visible');
        } else {
            $closeIcon.removeClass('visible');
        }
    });

    // Clear input and hide close icon when the close icon is clicked
    $closeIcon.on('click', function () {
        $input.val(''); // Clear the input field
        $closeIcon.removeClass('visible'); // Hide the close icon
    });
});


// search-close-icon end




$(".search-close-icon").on("click",function(){
    $("#predictiveSearchSection").hide();
})



// stuck start

$(document).ready(function () {
    const $message = $('.stuck__message');
    const $closeIcon = $('.stuck__close');
    const $supportButton = $('.stuck__support');
    
    // On clicking the "Contact support" button
    $supportButton.find('button').on('click', function () {
        $message.slideDown(300); // Slide down the message section
        $closeIcon.css('opacity', '1'); // Fade in the close icon
        $supportButton.hide(); // Hide the "Contact support" section
    });

    // On clicking the "Close" icon
    $closeIcon.on('click', function () {
        $message.slideUp(300); // Slide up the message section
        $closeIcon.css('opacity', '0'); // Fade out the close icon
        $supportButton.show(); // Show the "Contact support" section
    });
});



// stuck end




// -----------chart-toggle-btn start----------




let pillButtonOnText = $('.pill-button-selection_on'),
    pillButtonOffText = $('.pill-button-selection_off'),
    pillButtonHighlight = $('.pill-button-highlight'),
    pillButtonOnTextWidth = pillButtonOnText.outerWidth(),
    pillButtonOffTextWidth = pillButtonOffText.outerWidth(),
    pillButtonOnTextPosition = pillButtonOnText.position(),
    pillButtonOffTextPosition = pillButtonOffText.position(),
    pillButtonInput = $('.pill-button-input');


$('.pill-button-selection').on('click', function () {
    if (!$(this).hasClass('pill-button-selection_active')) {
        $('.pill-button-selection').removeClass('pill-button-selection_active');
        $(this).addClass('pill-button-selection_active');

        if ($(this).hasClass('pill-button-selection_off') && pillButtonInput.prop('checked', true)) {
            pillButtonInput.prop('checked', false);
            pillButtonHighlight.css({
                'width': pillButtonOffTextWidth,
                'left': pillButtonOffTextPosition.left
            });
            console.log("Is Checked - OFF");
            $('.kg').removeClass('active');
            $('.lbs').addClass('active');
        }
        else {
            pillButtonInput.prop('checked', true);
            pillButtonHighlight.css({
                'width': pillButtonOnTextWidth,
                'left': pillButtonOnTextPosition.left
            });
            console.log("Is Checked - ON");
            $('.kg').addClass('active');
            $('.lbs').removeClass('active');
        }
    }
});


// -----------chart-toggle-btn end----------




// Performance start



if ($(window).width() < 768) {
    $(".Performance__title").click(function () {
        const $item = $(this).closest(".Performance__item");

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $item.find(".Performance__content").slideUp();
        } else {
            $(".Performance__title").removeClass("active");
            $(".Performance__content").slideUp();
            $(this).addClass("active");
            $item.find(".Performance__content").slideDown();
        }
    });
}





// Performance end
